import { cn } from '../../../../lib/cn';
import { TONG_AVATAR } from '../../constants';
import { chiSoTheoTen, chuCaiDau } from '../../nghiep-vu/nhiem-vu';

/** Avatar chữ cái đầu; cùng tên luôn cùng màu. */
export function UserAvatar({ name, className }: { name: string; className?: string }) {
  return (
    <span
      title={name}
      className={cn(
        'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 border-[var(--bg-surface)] text-2xs font-semibold leading-none text-content-inverse',
        TONG_AVATAR[chiSoTheoTen(name, TONG_AVATAR.length)],
        className,
      )}
    >
      {chuCaiDau(name)}
    </span>
  );
}
